<template>
  <div class="distrbution">
    <el-card>
      <div class="title">
        <span></span>
        <p>户口性质</p>
      </div>
      <!-- 总人口 -->
      <div class="count">
        <el-row :gutter="20" justify="center">
          <el-col :span="7">
            <div class="count_info">
              <div class="conet_sub">
                <h3>{{ objesList.cnt }}</h3>
                <p>{{ objesList.title }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="count_info">
              <div class="conet_sub">
                <h3>{{ objesList.cnt2 }}</h3>
                <p>{{ objesList.title2 }}</p>
              </div>
            </div></el-col
          >
          <el-col :span="7">
            <div class="count_info">
              <div class="conet_sub">
                <h3>{{ objesList.cnt3 }}</h3>
                <p>{{ objesList.title3 }}</p>
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { natureListLable } from "@/network";
export default {
  data() {
    return {
      objesList: {},
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const { code, data } = await natureListLable();
      if (code == 200) {
        this.objesList = data;
      }
    },
  },
};
</script>

<style scoped lang="less">
.distrbution {
  .title {
    display: flex;
    align-items: center;
    span {
      width: 2px;
      height: 16px;
      background: #0079fe;
      margin: 0 10px 0 0px;
    }
  }
  .count {
    padding: 20px 0 10px 0;
    .el-row {
      text-align: center;
      .count_info {
        width: 140%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        .conet_sub {
          margin: 0 10px;
          p {
            padding: 10px 4px 0;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #666666;
          }
          h3 {
            font-size: 20px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
